import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion } from 'react-bootstrap';
import TransferenciaEstadoService from '../../../services/transferenciasEstado';
import { Link } from 'react-router-dom';
import Exportar from '../../shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [competencia, setCompetencia] = useState("");
    const [tipo, setTipo] = useState("");
    const [ano, setAno] = useState("");
    const [destinatario, setDestinatario] = useState("");
    const [origem, setOrigem] = useState("");
    const [programa, setPrograma] = useState("");

    const busca = async (query) => {
        if (query == "") {
            await props.fetchFiscais()
            setCompetencia("")
            setTipo("")
            setAno("")
            setDestinatario("")
            setOrigem("")
            setPrograma("")
        } else {
            var response = await TransferenciaEstadoService.buscar(query)
            if (response.data.length >= 1) {
                props.setTransferencias(response.data)
                props.setVazio(false)
                setCompetencia("")
                setTipo("")
                setAno("")
                setDestinatario("")
                setOrigem("")
                setPrograma("")
            } else {
                props.setVazio(true)
                setCompetencia("")
                setTipo("")
                setAno("")
                setDestinatario("")
                setOrigem("")
                setPrograma("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (competencia !== "") {
            prepQuery += `&competencia=${encodeURI(competencia)}`
            props.setPeriodo({
                inicio: `${competencia}/${ano || '2015'}`,
                fim: `${competencia}/${ano || new Date().getFullYear()}`
            });
        }
        if (destinatario !== "false" && destinatario != "false" && destinatario !== "") prepQuery = prepQuery + `&destinatario=${encodeURI(destinatario)}`;
        if (tipo !== "false" && tipo != "false" && tipo !== "") prepQuery = prepQuery + `&tipo=${encodeURI(tipo)}`;
        if (origem !== "false" && origem != "false" && origem !== "") prepQuery = prepQuery + `&origem=${encodeURI(origem)}`;
        if (ano !== "false" && ano != "false" && ano !== "") {
            prepQuery = prepQuery + `&ano=${ano}`;
            if (competencia !== "") {
                props.setPeriodo({
                    inicio: `${competencia}/${ano}`,
                    fim: `${competencia}/${ano}`
                })
            } else {
                props.setPeriodo({
                    inicio: `Janeiro/${ano}`,
                    fim: `Dezembro/${ano}`
                })
            }
        }
        if (programa !== "false" && programa != "false" && programa !== "") prepQuery = prepQuery + `&programa=${encodeURI(programa)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={2}>
                        <Col lg={9}>
                            <Row xs={1} lg={2}>
                                <Col xs={12} lg={4}>
                                    <Form.Group className="mb-3" controlId="competencia">
                                        <FloatingLabel
                                            label="Competência"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="competencia"
                                                name="competencia"
                                                onChange={e => setCompetencia(e.target.value)}
                                            >
                                                <option value="">TODAS</option>
                                                <option value="Janeiro">Janeiro</option>
                                                <option value="Fevereiro">Fevereiro</option>
                                                <option value="Março">Março</option>
                                                <option value="Abril">Abril</option>
                                                <option value="Maio">Maio</option>
                                                <option value="Junho">Junho</option>
                                                <option value="Julho">Julho</option>
                                                <option value="Agosto">Agosto</option>
                                                <option value="Setembro">Setembro</option>
                                                <option value="Outubro">Outubro</option>
                                                <option value="Novembro">Novembro</option>
                                                <option value="Dezembro">Dezembro</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={2}>
                                    <Form.Group className="mb-3" controlId="Ano">
                                        <FloatingLabel
                                            label="Ano"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="ano"
                                                name="ano"
                                                onChange={e => setAno(e.target.value)}
                                            >
                                                <option>SELECIONE</option>
                                                <option value="2025">2025</option>
                                                <option value="2024">2024</option>
                                                <option value="2023">2023</option>
                                                <option value="2022">2022</option>
                                                <option value="2021">2021</option>
                                                <option value="2020">2020</option>
                                                <option value="2019">2019</option>
                                                <option value="2018">2018</option>
                                                <option value="2017">2017</option>
                                                <option value="2016">2016</option>
                                                <option value="2015">2015</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col lg={2}>
                                    <Form.Group className="mb-3" controlId="Plataforma">
                                        <FloatingLabel
                                            label="Tipo"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="tipo"
                                                name="tipo"
                                                onChange={e => setTipo(e.target.value)}
                                            >
                                                <option>SELECIONE</option>
                                                <option value="Obrigatória">Obrigatória</option>
                                                <option value="Voluntária">Voluntária</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={4}>
                                    <Form.Group className="mb-3" controlId="destinatario">
                                        <FloatingLabel
                                            label="Destinatário"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="destinatario"
                                                name="destinatario"
                                                onChange={e => setDestinatario(e.target.value)}
                                            >
                                                <option>SELECIONE</option>
                                                <option value="Prefeitura Municipal de Macuco">Prefeitura Municipal de Macuco</option>
                                                <option value="Fundo Municipal de Saúde">Fundo Municipal de Saúde</option>
                                                <option value="Fundo Municipal de Educação">Fundo Municipal de Educação</option>
                                                <option value="Fundo Municipal de Assistência Social">Fundo Municipal de Assistência Social</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={4}>
                                    <Form.Group className="mb-3" controlId="origem">
                                        <FloatingLabel
                                            label="Origem"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="origem"
                                                name="origem"
                                                onChange={e => setOrigem(e.target.value)}
                                            >
                                                <option>SELECIONE</option>
                                                <option value="FUNDEB - ICMS">FUNDEB - ICMS</option>
                                                <option value="ICMS">ICMS</option>
                                                <option value="FUNDEB - IPI">FUNDEB - IPI</option>
                                                <option value="FUNDEB - IPVA">FUNDEB - IPVA</option>
                                                <option value="IPI">IPI</option>
                                                <option value="IPVA">IPVA</option>
                                                <option value="ROYALTIES">ROYALTIES</option>
                                                <option value="PASEP - IPI">PASEP - IPI</option>
                                                <option value="PASEP - ROYALTIES">PASEP - ROYALTIES</option>
                                                <option value="FUNDEB - ICMS - LEI EST. 5.647/10">FUNDEB - ICMS - LEI EST. 5.647/10</option>
                                                <option value="ICMS - LEI EST. 5.647/10">ICMS - LEI EST. 5.647/10</option>
                                                <option value="FUNDEB - IPVA - LEI EST. 5.647/10">FUNDEB - IPVA - LEI EST. 5.647/10</option>
                                                <option value="ICM - LEI EST. 5.647/10">ICM - LEI EST. 5.647/10</option>
                                                <option value="IPVA - LEI EST. 5.647/10">IPVA - LEI EST. 5.647/10</option>
                                                <option value="FUNDEB - ICMS - DECRETO 44.814/2014">FUNDEB - ICMS - DECRETO 44.814/2014</option>
                                                <option value="ICMS - DECRETO 44.814/2014">ICMS - DECRETO 44.814/2014</option>
                                                <option value="COMP. LC 194/2022">COMP. LC 194/2022</option>
                                                <option value="FUNDEB - ICMS - LC 194/2022">FUNDEB - ICMS - LC 194/2022</option>
                                                <option value="ICMS - LC 194/2022">ICMS - LC 194/2022</option>
                                                <option value="FUNDEB - ICMS - LEI EST. 6.136/11">FUNDEB - ICMS - LEI EST. 6.136/11</option>
                                                <option value="ICMS - LEI EST. 6.136/11">ICMS - LEI EST. 6.136/11</option>
                                                <option value="FUNDEB - IPVA - LEI EST. 6.136/11">FUNDEB - IPVA - LEI EST. 6.136/11</option>
                                                <option value="ICM - LEI EST. 6.136/11">ICM - LEI EST. 6.136/11</option>
                                                <option value="ICMS - JUROS E MORA">ICMS - JUROS E MORA</option>
                                                <option value="FUNDEB - ICMS - JUROS E MORA">FUNDEB - ICMS - JUROS E MORA</option>
                                                <option value="IPVA - JUROS E MORA">IPVA - JUROS E MORA</option>
                                                <option value="FUNDEB - IPVA - JUROS E MORA">FUNDEB - IPVA - JUROS E MORA</option>
                                                <option value="Governo do Estado do Rio de Janeiro">Governo do Estado do Rio de Janeiro</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={4}>
                                    <Form.Group className="mb-3" controlId="programa">
                                        <FloatingLabel
                                            label="Programa"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="programa"
                                                name="programa"
                                                onChange={e => setPrograma(e.target.value)}
                                            >
                                                <option>SELECIONE</option>
                                                <option value="Somando Forças">Somando Forças</option>
                                                <option value="Assistência Farmacêutica">Assistência Farmacêutica</option>
                                                <option value="Gestão e Fortalecimento da Atenção à Saúde">Gestão e Fortalecimento da Atenção à Saúde</option>
                                                <option value="Fortalecimento da Gestão do SUS e da Participação Social">Fortalecimento da Gestão do SUS e da Participação Social</option>
                                                <option value="Proteção Social Básica de Assistência Social">Proteção Social Básica de Assistência Social</option>
                                                <option value="Gestão Operacional da Polícia">Gestão Operacional da Polícia</option>
                                                <option value="Promoção da Saúde e Vigilância Epidemiológica">Promoção da Saúde e Vigilância Epidemiológica</option>
                                                <option value="Vigilância Ambiental e Vigilância Sanitária">Vigilância Ambiental e Vigilância Sanitária</option>
                                                <option value="Ampliação e Qualificação da Atenção Básica">Ampliação e Qualificação da Atenção Básica</option>
                                                <option value="Promoção da Assistência Ambulatorial e Hospitalar">Promoção da Assistência Ambulatorial e Hospitalar</option>
                                                <option value="Organização da Oferta de Assistência nas Linhas de Cuidado Prioritárias">Organização da Oferta de Assistência nas Linhas de Cuidado Prioritárias</option>
                                                <option value="Coordenação Federativa e Desenvolvimento Territorial">Coordenação Federativa e Desenvolvimento Territorial</option>
                                                <option value="Vigilância em Saúde">Vigilância em Saúde</option>
                                                <option value="Atenção à Saúde">Atenção à Saúde</option>
                                                <option value="Gestão do SUAS, Proteção Social e Redução da Pobreza">Gestão do SUAS, Proteção Social e Redução da Pobreza</option>
                                                <option value=" Estratégia e Gestão da Saúde"> Estratégia e Gestão da Saúde</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/transferenciasestado'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                     <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.transferencias} nome={"Transferencias"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#2047e508-e23c-4c6b-b9c5-847240cfb819" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
